'use client'

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel'
import { ImageHelper } from '@/lib/helpers/image.helper'
import { useTranslations } from 'next-intl'
import Image from 'next/image'

interface SlideItem {
  title: string
  subtitle: string
  logo: string
  image: {
    mobile: string
    desktop: string
  }
}

export const PickleBallPartners = () => {
  const t = useTranslations()
  const slides: SlideItem[] = [
    {
      title: t('pickleball_tennis_hardcode.partners.facolos.title'),
      subtitle: t('pickleball_tennis_hardcode.partners.facolos.subtitle'),
      logo: '/image/2026/12/26/mceclip29.png',
      image: {
        mobile: '/image/2026/12/26/mceclip25.jpg',
        desktop: '/image/2026/12/26/mceclip15.jpg',
      },
    },
    {
      title: t('pickleball_tennis_hardcode.partners.reclub.title'),
      subtitle: t('pickleball_tennis_hardcode.partners.reclub.subtitle'),
      logo: '/image/2026/12/26/mceclip30.png',
      image: {
        mobile: '/image/2026/12/26/mceclip26.jpg',
        desktop: '/image/2026/12/26/mceclip14.jpg',
      },
    },
  ]

  return (
    <section className='my-10 bg-neutral-200 px-4 py-6 md:mx-10 md:my-20 md:rounded-3xl md:p-14'>
      <Carousel
        className='w-full'
        opts={{ loop: false, align: 'start', containScroll: false }}
      >
        <CarouselContent>
          {slides.map((slide, index) => (
            <CarouselItem key={index}>
              <div className='grid grid-cols-12 gap-4 md:gap-8'>
                <div className='col-span-12 flex flex-col items-center justify-center md:col-span-5'>
                  <Image
                    src={ImageHelper.getImageUrlCdn(slide.logo)}
                    alt={slide.title}
                    width={100}
                    height={100}
                    className='aspect-[594/284] h-auto w-auto object-contain px-5 md:px-20 2xl:px-40'
                  />
                  <p className='mt-4 text-sm font-normal leading-none text-primary max-md:mb-4 md:text-xl'>
                    {slide.subtitle}
                  </p>
                </div>
                <picture className='relative col-span-12 w-full md:col-span-7'>
                  <source
                    media='(max-width: 768px)'
                    srcSet={ImageHelper.getImageUrlCdn(slide.image.mobile)}
                  />
                  <Image
                    src={ImageHelper.getImageUrlCdn(slide.image.desktop)}
                    alt={slide.title}
                    width={960}
                    height={552}
                    className='w-full rounded-lg object-cover'
                  />
                </picture>
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselNavigation />
      </Carousel>
    </section>
  )
}

function CarouselNavigation() {
  return (
    <>
      <CarouselPrevious
        className='absolute -left-3 top-1/2 h-7 w-7 -translate-y-1/2 md:-left-9'
        variant='black'
        hideIfStart
      />
      <CarouselNext
        className='absolute -right-3 top-1/2 h-7 w-7 -translate-y-1/2 md:-right-9'
        variant='black'
        hideIfEnd
      />
    </>
  )
}
